import { USER_DOMAIN } from '@/shared/constants/user-domain.constant';

export const getDomainFromPathname = (pathname: string) => {
	const [, pathDomain] = pathname.split('/');

	return Object.values(USER_DOMAIN).find((domain) => domain === pathDomain);
};

export const getCurrentDomain = () => getDomainFromPathname(window.location.pathname) ?? USER_DOMAIN.YACHTING;
